import messageUtils from "@utils/messageUtils";
import axios from "axios";
import i18n from "@i18n";

import Jsona from "jsona";

const dataFormatter = new Jsona();

export const state = {
  snoozeNotification: null,
  shouldFetchSnoozeNotifications: false,
};

export const actions = {
  async getSnoozeNotifications({ commit }, payload) {
    try {
      const response = await axios.get(`/v1/snooze_notifications${payload}`);
      return {
        data: dataFormatter.deserialize(response.data),
        headers: response.headers,
      };
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async addSnoozeNotification({ commit }, payload) {
    try {
      await axios.post("/v1/snooze_notifications", {
        ...payload,
      });
      messageUtils.showSuccess(i18n.t("snooze_notifications.requests.add"));
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async updateSnoozeNotification({ commit }, payload) {
    try {
      await axios.patch(`/v1/snooze_notifications/${payload.id}`, {
        ...payload,
      });
      messageUtils.showSuccess(i18n.t("snooze_notifications.requests.update"));
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async deleteSnoozeNotification({ commit }, payload) {
    try {
      await axios.delete(`/v1/snooze_notifications/${payload}`);
      messageUtils.showSuccess(i18n.t("snooze_notifications.requests.delete"));
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

};

export const mutations = {
  setSnoozeNotification(state, notification) {
    state.snoozeNotification = notification;
  },

  setShouldFetchSnoozeNotifications(state, value) {
    state.shouldFetchSnoozeNotifications = value;
  },
  
};
